/** @generated */
// cspell:disable

/** @typedef {import('axios').AxiosInstance} AxiosInstance */

import { SweetPath } from 'sweet-path';

/**
 * @typedef {import('./invoice-get-action-body').InvoiceGetActionBody} InvoiceGetActionBody
 */

/**
 * @typedef {import('./invoice-get-action-response').InvoiceGetActionResponse} InvoiceGetActionResponse
 */

/**
 * The path of the InvoiceGetAction action.
 */
export const invoiceGetActionPath = new SweetPath('/api/finance/invoice/{invoice_id}', { path: '{param}' });

/**
 * Creates a contextualized InvoiceGetAction action.
 *
 * @param {AxiosInstance} axios
 */
export default function createInvoiceGetAction(axios) {
  /**
   * The invoiceGetAction action.
   *
   * @param { { headers: Object<string,string>,parameters: Object<string,string|number|boolean>,query: {limit?: number; offset?: number; filter?: Object<string,string|number|boolean>;, sort?: {by: string; order: string;}} } }
   *
   * @returns {Promise<InvoiceGetActionResponse>}
   */
  function invoiceGetAction({ headers = {}, parameters = {}, query = {} } = {}) {
    const path = invoiceGetActionPath.insert(parameters);

    return axios.get(path, { params: query, headers });
  }

  return invoiceGetAction;
}
